//CDMSTimeCellValidator - extends CellValidator

// validates time cells.

import * as moment from 'moment';
import {CellValidator, ValidationError} from "../cell-validation";
import {stringIsTime} from "../../../common-functions";


export function CDMSTimeCellValidator(cdms_field) {
    this.base = CellValidator;
    //console.log("calling constructor?");
    this.base(cdms_field);
    //this.init(cdms_field);
}
CDMSTimeCellValidator.prototype = new CellValidator;

CDMSTimeCellValidator.prototype.validateFieldControlTypeValidation = function (data, duplicateCheckEnabled, duplicateCheckFields) {

/*
    //george's time checking

    var value = data.value;

    var timeContentValid = true;

    if (!is_empty(value) && !stringIsTime(value))
        timeContentValid = false;
    else if (value.indexOf(".") > -1)
        timeContentValid = false;
    else if (value.indexOf(":") === -1)
        timeContentValid = false;

    if (!timeContentValid)
        this.errors.push(new ValidationError(this.cdms_field, "Value is not a valid time (hh:mm)."));

*/
    // when checking for duplicate, display a fied error if a key field is blank
    if ((data.value == null || data.value == "") && duplicateCheckEnabled && duplicateCheckFields.includes(data.colDef.cdmsField.DbColumnName)
          && !this.validation.includes("required")) {
      return this.errors.push(new ValidationError(this.cdms_field, "Duplicate Checking field cannot be blank."));
    }

    if (data.value == null || data.value == "")
        return this.errors;

    if ((data.value.length < 19) && (!stringIsTime(data.value))) {
      this.errors.push(new ValidationError(this.cdms_field, "Value is either not a time, or is in an invalid time format; please use hh:mm format."));
      return this.errors;
  }

  let time;
  if (data.value.length >= 19) { // the value is a datetime or something similar in size
    const timeString = data.value.split("T")[1];
    time = moment(timeString, ['HH:mm:ss'], true);
  }
  else { // the value is a time mosty entered by the user in the grids
    time = moment(data.value, ['HH:mm'], true);
  }

  if (!time.isValid()) {
      this.errors.push(new ValidationError(this.cdms_field, "Value is not a time (hh:mm)."));
  }

  return this.errors;
};
